// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__c9wwN","buttons":"Footer_buttons__bnuyv"};